import { module as ModuleJS } from "modujs";
import { loadScript } from "./../utils/loadScript";

export default class extends ModuleJS {
    constructor(m) {
        super(m);

        this.markersElements = this.$("marker");
        this.infoWindows = [];
        this.markers = [];
        this.markersVisible = [];

        // after fitbounds
        this.maxZoom = 11;

        this.markerClustererOptions = {
            gridSize: 15,
            imagePath: `${config.theme}/images/markers/m`,
        };

        this.useClusters = false;
    }

    init() {
        this.setupMap = this.setupMap.bind(this);

        window.soGoogleLoading = window.soGoogleLoading || false;
        window.soGoogleLoaded = window.soGoogleLoaded || false;
        window.soGoogleReadyActions = window.soGoogleReadyActions || [];

        window.soGoogleReadyActions.push(this.setupMap);

        if (!window.soGoogleLoading) {
            window.soGoogleLoading = true;

            const loadPromises = [];

            if (this.useClusters) {
                loadPromises.push(
                    loadScript(
                        "https://unpkg.com/@googlemaps/markerclustererplus/dist/index.min.js"
                    )
                );
            }

            loadPromises.push(
                loadScript(
                    `https://maps.googleapis.com/maps/api/js?key=${soMaps.key}`
                )
            );

            Promise.all(loadPromises).then((results) => {
                window.soGoogleLoaded = true;
                window.soGoogleLoading = true;

                window.soGoogleReadyActions.forEach((action) => action());
                window.soGoogleReadyActions = [];
            });
        }
    }

    setupMap() {
        this.map = new google.maps.Map(this.el, {
            zoom: 9.81,
            // scrollwheel: false,
            center: new google.maps.LatLng(47.4489542, 5.6399455),
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            // disableDefaultUI: true,
        });

        this.setupMarkers();
        this.fixEqualMarkers();
        this.setupMarkerClusterer();

        this.center();

        this.bindEvents();
    }

    setupMarkers() {
        // Markers map
        this.markersElements.forEach((element) => this.setupMarker(element));
    }

    setupMarker(markerEl) {
        const lat = this.getData("lat", markerEl);
        const lng = this.getData("lng", markerEl);
        if (!lat || !lng) return;

        const latLng = new google.maps.LatLng(lat, lng);

        const baseIcon = {
            // url: config.theme + "/dist/images/marker@2x.png",
            // scaledSize: new google.maps.Size(27, 37),
            // origin: new google.maps.Point(0, 0),
            // anchor: new google.maps.Point(0, 37),
        };

        // create marker
        const marker = new google.maps.Marker({
            id: this.getData("id", markerEl) || "",
            type: this.getData("type", markerEl) || "",
            position: latLng,
            map: this.map,
            // icon: baseIcon,
            zIndex: 10,
        });

        marker._el = markerEl;

        // if marker contains HTML, add it to an infoWindow
        if (markerEl.innerHTML) {
            // create info window
            marker.infowindow = new google.maps.InfoWindow({
                content: markerEl.innerHTML,
            });

            // show info window when marker is clicked
            google.maps.event.addListener(marker, "click", function () {
                var event = new CustomEvent("gmap-item-active", {
                    detail: {
                        id: this.id,
                        type: this.type,
                    },
                });
                document.dispatchEvent(event);
            });

            google.maps.event.addListener(
                marker.infowindow,
                "closeclick",
                function () {
                    var event = new CustomEvent("gmap-item-active", {
                        detail: {
                            id: null,
                        },
                    });
                    document.dispatchEvent(event);
                    //- marker.setIcon(getMarkerBaseIcon(marker._el));
                }
            );
        }

        marker.setMap(this.map);

        this.markers.push(marker);
        this.infoWindows.push(marker.infowindow);

        return marker;
    }

    setupMarkerClusterer() {
        if (!this.useClusters) return;

        // Add a marker clusterer to manage the markers.
        if (this.markerClusterer) {
            this.markerClusterer.setMap(null);
        }

        this.markerClusterer = new MarkerClusterer(
            this.map,
            this.markersVisible,
            this.markerClustererOptions
        );
    }

    fixEqualMarkers() {
        const locations = new Map();

        this.markers.forEach((marker) => {
            const position = marker.getPosition();
            const lat = position.lat();
            const lng = position.lng();
            const key = `${lat}_${lng}`;

            if (locations.has(key)) {
                const newLat = lat + (Math.random() - 0.5) / (3 * 10000);
                const newLng = lng + (Math.random() - 0.5) / (3 * 10000);
                const newKey = `${newLat}_${newLng}`;
                const newPosition = new google.maps.LatLng(newLat, newLng);

                marker.setPosition(newPosition);

                locations.set(newKey, 1);
            } else {
                locations.set(key, 1);
            }
        });
    }

    setAllMarkersDefaultIcon() {
        // for (let index = 0; index < this.markers.length; index++) {
        //   // const marker = this.markers[index];
        //   // marker.setIcon(baseIcon);
        // }
    }

    closeAllInfoWindows() {
        for (var i = 0; i < this.infoWindows.length; i++) {
            this.infoWindows[i].close();
        }
    }

    filterBy(key, value) {
        const bounds = new google.maps.LatLngBounds();
        const markersVisible = [];

        this.markers.forEach((marker) => {
            const shouldBeVisible = marker[key] === value;
            marker.setVisible(shouldBeVisible);

            if (shouldBeVisible) {
                markersVisible.push(marker);
                bounds.extend(marker.position);
            }
        });

        this.markersVisible = markersVisible;
        this.map.fitBounds(bounds);
        const currentZoom = this.map.getZoom();
        if (currentZoom > this.maxZoom) {
            this.map.setZoom(this.maxZoom);
        }
        this.setupMarkerClusterer();
    }

    center() {
        if (this.markers.length > 0) {
            const bounds = new google.maps.LatLngBounds();

            // loop through all markers and create bounds
            this.markers.forEach(function (marker, i) {
                var latlng = new google.maps.LatLng(
                    marker.position.lat(),
                    marker.position.lng()
                );
                bounds.extend(latlng);
            });

            // only 1 marker?
            if (this.markers.length == 1) {
                // set center of map
                this.map.setCenter(bounds.getCenter());
                this.map.setZoom(7);
            } else {
                // fit to bounds
                this.map.fitBounds(bounds);
            }
        }
    }

    onGmapMarkerActive(event) {
        const id = event.detail.id;
        if (!id) return;

        const marker = this.markers.find((m) => m.id === id);
        this.closeAllInfoWindows();
        this.setAllMarkersDefaultIcon();

        // map.setZoom(14);
        this.map.setCenter(marker.getPosition());
        marker.infowindow.open(map, marker);
    }

    bindEvents(el) {
        document.addEventListener("gmap-item-active", this.onGmapMarkerActive);
    }

    update(newContainer) {
        // this.bindEvents(newContainer);
    }

    destroy(oldContainer) {
        // this.el.removeEventListener("click", this.onClick);
    }
}
